@if (view && ViewToTextMap) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <label class="fs-32">{{ ViewToTextMap[view].title }}</label>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p>{{ ViewToTextMap[view].helperText }}</p>
      </div>
    </div>
    <div class="row row-padding-top-lg">
      <div class="offset-3 col-6">
        <app-client-vendor-search
          (searchEvent)="search($event)"
          (advancedSearchEvent)="advancedSearch($event)"
          [companyTypeSearchText]="'Vendor Name'"
        ></app-client-vendor-search>
      </div>
    </div>
  </div>
}
